var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{class:{ 'page-wrapper': true, 'overlay': _vm.menuOpen }},[(_vm.content)?_c(_vm.content.component,{tag:"component",attrs:{"content":_vm.content}}):_c('div',[_vm._v("\n    Something to say we do not have any content..??\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }